'use strict';

angular.module('rmRole', []);

require('./controller');
require('./resources');
require('./directives');
require('./routes');
